import LoginComponent from '../login-component';
import LoginCheckbox from '../ui-elements/login-checkbox';
import FormActions from '../../logic/form-actions';
import {localize} from '../../infrastructure/localization';

import './product-information-checkbox.scss';

export default class ProductInformationCheckbox extends LoginComponent {

    constructor(props) {
        super(props);
    }

    render() {
        if (!this.state.uiState.form.showProductInformation) {
            return null;
        }

        return (
            <div className="show-product-information-placeholder">
                <LoginCheckbox
                    componentId={this.state.componentId}
                    checked={!this.state.loginModel.sendProductInformation}
                    onChange={(e) => FormActions.changeSendProductInformation(this.state.componentId)}
                    label={localize('form-components.product-information')}
                    title={localize('form-components.product-information-title')}
                    gaEventCategory={this.state.paramModel.tracking.ga.productInformationCheckBox.category}
                    gaEventAction={this.state.paramModel.tracking.ga.productInformationCheckBox.action} />
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/form-components/product-information-checkbox.jsx
 **/